import { ReactElement } from 'react';

interface Props<T> {
  children: (props: T) => ReactElement;
}

export const ClonePropsComponent = <T,>(props: Props<T>): ReactElement => {
  const { children, ...other } = props;

  return children(other as T);
};
